
import { ICreateItemProcessoRiscosInteresseUseCase } from "../../../presentation/useCases/create/create_item_processo_riscos_interesse_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CreateProcessoRiscosInteresseUseCase

export class CreateItemProcessoRiscosInteresseUseCase implements ICreateItemProcessoRiscosInteresseUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async createItemProcessoRiscosInteresse(IdItemProcesso: number, Descricao: string | null, Expectativa: string | null, Acompanhamento: string | null, ResultadosAlcancados: string | null
 ): Promise<void> {
    
    await this.repository.createItemProcessoRiscosInteresse(IdItemProcesso, Descricao, Expectativa, Acompanhamento, ResultadosAlcancados);
  }
}